import { useState } from "react";

const InputCalc = (props) => {
  const {
    i,
    item,
    inputField,
    calculateDaysAmount,
    getIfisDisabledWhenDayEnds,
    returnedValue,
  } = props;
  const [rateValueLocal, setRateValueLocal] = useState(null);

  return (
    <div className="flex items-center gap-2">
      {/* Single input = DAILY RATE */}
      <input
        type="number"
        min="0"
        step={
          inputField?.decimalCount
            ? 1 / Math.pow(10, inputField.decimalCount)
            : "1"
        }
        className="block w-32 rounded-md border-gray-300 text-sm shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
        style={{
          cursor:
            getIfisDisabledWhenDayEnds(i, item) === true
              ? "not-allowed"
              : "unset",
          backgroundColor:
            getIfisDisabledWhenDayEnds(i, item) === true ? "#f9fafb" : "unset",
        }}
        placeholder="Daily rate"
        value={rateValueLocal}
        onChange={(e) => {
          if (e.target.value < 0) {
            e.target.value = 0;
          }
          setRateValueLocal(e.target.value);
          returnedValue(e.target.value * calculateDaysAmount(i));
        }}
        disabled={getIfisDisabledWhenDayEnds(i, item)}
      />
      <span className="text-sm text-gray-500 select-none">
        × {calculateDaysAmount(i)}
      </span>
    </div>
  );
};

export default InputCalc;
